
import { apiSlice } from '../../app/api/apiSlice'
// Automatically created using reduxslicer by Simo Virokannas, 2023

export const comboinlayoutApi = apiSlice.injectEndpoints ({ 
  endpoints: (builder) => ({
    listComboInLayouts: builder.query ({
      query: (params) => `v2/comboinlayout/${params ? "?" + new URLSearchParams(Object.entries(params)).toString() : ""}`,
      keepUnusedDataFor: 1,
      providesTags: ["ComboInLayout"]
    }),
    getComboInLayout: builder.query ({
      query: (comboinlayout_id) => `v2/comboinlayout/${comboinlayout_id}/`,
      keepUnusedDataFor: 1,
      providesTags: ["ComboInLayout"]
    }),

    updateComboInLayout: builder.mutation ({
      query: ({comboinlayout_id, data}) => ({
        url: `v2/comboinlayout/${comboinlayout_id}/`,
        method: 'PUT',
        body: data
      }),
      invalidatesTags: ["ComboInLayout"]
    }),
    deleteComboInLayout: builder.mutation ({
      query: (comboinlayout_id) => ({
        url: `v2/comboinlayout/${comboinlayout_id}/`,
        method: 'DELETE'
      }),
      invalidatesTags: ["ComboInLayout"]
    }),
    createComboInLayout: builder.mutation ({
      query: (data) => ({
        url: `v2/comboinlayout/`,
        method: 'POST',
        body: data
      }),
      invalidatesTags: ["ComboInLayout"]
    }),
  })
})


export const {
  useListComboInLayoutsQuery,
  useLazyListComboInLayoutsQuery,
  useGetComboInLayoutQuery,
  useLazyGetComboInLayoutQuery,

  useUpdateComboInLayoutMutation,
  useDeleteComboInLayoutMutation,
  useCreateComboInLayoutMutation
} = comboinlayoutApi
